import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpContextToken } from "@angular/common/http";

export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

@Injectable({providedIn : 'root'})
export class LoadingService {
  isLoading$ = new Subject<boolean>();

  show(): void
  {
    this.isLoading$.next(true);
  }

  hide(): void
  {
    this.isLoading$.next(false);
  }
}
